module.exports = __webpack_public_path__ + "static/media/bootstrap-icons.e07b538a.woff2";